import FOOTER from '../constants/footer';
export default FOOTER;
